/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TopBar_user = {
    readonly " $fragmentRefs": FragmentRefs<"AccountNav_user" | "Rewards_user" | "CartNav_user" | "Notifications_user">;
    readonly " $refType": "TopBar_user";
};
export type TopBar_user$data = TopBar_user;
export type TopBar_user$key = {
    readonly " $data"?: TopBar_user$data;
    readonly " $fragmentRefs": FragmentRefs<"TopBar_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TopBar_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "AccountNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Rewards_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "CartNav_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "Notifications_user",
      "args": null
    }
  ]
};
(node as any).hash = '7158036a09c9d13c7164a311163039cb';
export default node;
